const INTERNAL_ERROR_PATTERN = /\b(?:antix_|d1|r2|sqlite|sql|binding|runtime|environment|configuration|configured|mock(?:\s+data)?|cloudflare|workers?|pages|backend|server|api|stripe[_\s-]*(?:secret|key)|secret|webhook|migration|schema|development|debug)\b/i;

export function publicErrorMessage(error: unknown, fallback: string): string {
  if (!(error instanceof Error)) return fallback;
  const message = error.message.trim();
  if (!message || message.length > 180 || INTERNAL_ERROR_PATTERN.test(message)) return fallback;
  return message;
}
